import React, { useState, useRef, useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { ToastContainer, toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import OutpatientPage from './OutpatientPage'
import PatientPage from './PatientPage'
import DocumentView from './DocumentView'
import { Modal } from 'react-bootstrap'
import { IoIosClose } from 'react-icons/io'
import { FaBriefcaseMedical, FaComment, FaFile, FaUserCircle } from 'react-icons/fa'
import { useAuth } from '../../modules/auth'
import { useNavigate } from 'react-router-dom'
import axios from 'axios'
import DocumentModal from '../layout-inpatient/tab-components/DocumentModal'
import ChatModal from '../layout-inpatient/tab-components/ChatModal'
import { useClaimDetails } from '../../../hooks/useClaims'

const OutpatientPageWrapper: React.FC = () => {
  const auth = useAuth()
  const user = useAuth()
  const location = useLocation()
  const navigate = useNavigate()
  const claimDetails = location.state as { claimDetails: any }

  console.log('claimDetails', claimDetails)
  const [activeTab, setActiveTab] = useState<'claim' | 'dataPasien' | 'documents'>(
    'claim'
  )
  const [showConfirmation, setShowConfirmation] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [showCancelModal, setShowCancelModal] = useState(false)
  const [remark, setRemark] = useState('')
  const [showRemarkError, setShowRemarkError] = useState(false)
  const [isConfirmCancel, setIsConfirmCancel] = useState(false)
  // Form validation state - enable buttons only when required fields are filled
  const [isFormValid, setIsFormValid] = useState(false)
  const [isSaveClaim, setIsSaveClaim] = useState(false)
  // const [showGreeting, setShowGreeting] = useState(true)
  const outpatientPageRef = useRef<{
    handleSubmit: (e: React.FormEvent, type: 'save' | 'submit') => Promise<void>
  }>(null)
  // Add new state for current status
  const [currentStatus, setCurrentStatus] = useState<string>(
    claimDetails?.claimDetails?.status || ''
  )
  const [formData, setFormData] = useState<any>({
    diagnosis: '',
    diagnosis2: '',
    diagnosis3: '',
    diagnosis4: '',
    doctor: '',
    prescription: '',
    department: '',
    notes: '',
    specialTerms: '',
    // COMMENTED OUT - Estimasi Biaya data
    // costs: {},
    // excess: {},
    // totalBiaya: 0,
    supportingDiagnosis: Array(4).fill(''),
    selectedSupportingIcds: Array(4).fill(null),
  })
  // Superseding modal states
  const [showSupersedingModal, setShowSupersedingModal] = useState<boolean>(false)
  const [supersedingRemark, setSupersedingRemark] = useState<string>('')
  const [showSupersedingRemarkError, setShowSupersedingRemarkError] = useState<boolean>(false)
  const [currentSupersedingType, setCurrentSupersedingType] = useState<string>('')

  const [isChatModalOpen, setIsChatModalOpen] = useState<boolean>(false)
  const [isChatOpen, setIsChatOpen] = useState<boolean>(false)
  const [requiredDocuments, setRequiredDocuments] = useState<any[]>([])

  const {
    data: dataClaimDetails,
    refetch: refetchDetailsClaim
  } = useClaimDetails(claimDetails?.claimDetails?.claimNumber, true)

  if (!claimDetails?.claimDetails) {
    return <div>No claim details available</div>
  }

  // Update status when claimDetails changes
  useEffect(() => {
    if (dataClaimDetails?.status) {
      setCurrentStatus(dataClaimDetails.status)
    }
  }, [dataClaimDetails])

  const handleDefaultDocumentsReady = (docs: any[]) => {
    setRequiredDocuments(docs)
  }

  const tabStyle = {
    cursor: 'pointer',
    padding: '12px 16px',
    display: 'flex',
    alignItems: 'center',
    marginBottom: '0',
    backgroundColor: 'transparent',
    borderRadius: '8px',
    transition: 'all 0.2s ease-in-out',
    border: '1px solid transparent',
    marginRight: '8px',
  };

  const tabsContainerStyle = {
    display: 'flex',
    padding: '8px',
    backgroundColor: '#fff',
    borderRadius: '12px',
    boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
    marginBottom: '24px',
    marginTop: 140,
  }

  const activeTabStyle = {
    backgroundColor: '#EBF7F9',
    color: '#059BB6',
    border: '1px solid #E2EDF3',
    boxShadow: '0 2px 4px rgba(0,0,0,0.04)',
  }

  const tabIconStyle = {
    width: '20px',
    height: '20px',
    marginRight: '8px',
    transition: 'all 0.2s ease',
  }

  const activeIconStyle = {
    color: '#059BB6',
  }

  const tabTextStyle = {
    fontSize: '0.95rem',
    fontWeight: 500,
    transition: 'all 0.2s ease',
  }

  const getTabStyle = (isActive: boolean) => ({
    ...tabStyle,
    ...(isActive ? activeTabStyle : {}),
    ':hover': {
      backgroundColor: isActive ? '#EBF7F9' : '#F8FAFC',
      transform: 'translateY(-1px)',
      boxShadow: '0 4px 6px rgba(0,0,0,0.05)',
    },
  })

  const getLatestStatus = (doc: any) => {
    const docs = doc.document ?? []
    return docs.length ? docs[docs.length - 1].status : null
  }

  const handleFormDataChange = (newData: any) => {
    setFormData((prevData) => {
      const updatedFormData = {
        ...prevData,
        ...newData,
      }
      // Check if required fields are filled: diagnosis, doctor, department
      const requiredFieldsFilled =
        updatedFormData.diagnosis?.trim() !== '' &&
        updatedFormData.doctor?.trim() !== '' &&
        updatedFormData.department?.trim() !== ''

      const allDocumentsUploaded =
        requiredDocuments.length > 0 &&
        requiredDocuments.every((reqDoc) => {
          const matched = updatedFormData.documentsData?.find(
            (d: any) => d.label === reqDoc.label
          )

          return matched?.document?.length > 0
        })

      const hasUnresolvedRequestDocument =
        currentStatus === 'Pending on FGL'
          ? updatedFormData.documentsData?.some((doc: any) => {
            const latestStatus = getLatestStatus(doc)
            return (
              latestStatus === 'INVALID' ||
              latestStatus === 'Request Document'
            )
          })
          : false

      let isValid = false

      if (currentStatus === 'Pre-Registered') {
        isValid = requiredFieldsFilled && allDocumentsUploaded
      }

      if (currentStatus === 'Pending on FGL') {
        isValid =
          requiredFieldsFilled &&
          allDocumentsUploaded &&
          !hasUnresolvedRequestDocument
      }

      setIsFormValid(isValid)
      return updatedFormData
    })
  }

  const updateClaimStatus = async (claimNumber: string, remark: string) => {
    const apiUrl = `${process.env.REACT_APP_API_CLAIM_URL}/api/Claims/UpdateStatus`
    const payload = {
      claimNumber: claimNumber,
      status: 'Void',
      username: user.currentUser?.email,
      source: 'Provider',
      remarkRejectVoid: remark,
    }
    const headers = {
      Authorization: `Bearer ${auth?.currentUser?.token}` || `Bearer ${user.currentUser?.token}`,
    }

    try {
      const response = await axios.post(apiUrl, payload, { headers })

      if (!response.data.isSuccess) {
        throw new Error('Failed to submit IGL Request')
      }

      toast.success('Update claim status successfully!', {
        position: 'bottom-right',
        autoClose: 3000,
      })

      // Refetch data after successful update
      setIsLoading(true)
      navigate('/builder')
    } catch (error) {
      console.error('Error updating claim status:', error)
      toast.error('Failed to update claim status', {
        position: 'bottom-right',
        autoClose: 3000,
      })
    }
  }

  const updateClaimStatusSupersedingRequest = async (
    status: string,
    remark: string = 'Superseding Request'
  ) => {
    const apiUrl = `${process.env.REACT_APP_API_CLAIM_URL}/api/Claims/UpdateStatus`
    const payload = {
      claimNumber: claimDetails.claimDetails.claimNumber,
      status: `${status} Superseding Request`,
      username: user.currentUser?.email,
      source: 'Provider',
      remarkSuperseeding: remark,
    }
    const headers = {
      Authorization: `Bearer ${auth?.currentUser?.token}` || `Bearer ${user.currentUser?.token}`,
    }

    const response = await axios.post(apiUrl, payload, { headers })

    if (!response.data.isSuccess) {
      throw new Error('Failed to submit IGL Request')
    }

    toast.success('FGL Superseding Request submitted successfully!', {
      position: 'bottom-right',
      autoClose: 3000,
    })
  }

  const handleCancelClick = () => {
    setShowCancelModal(true)
  }

  const handleModalClose = () => {
    setShowCancelModal(false)
    setRemark('')
    setIsConfirmCancel(false)
  }

  const handleConfirmCancel = () => {
    if (!remark.trim()) {
      setShowRemarkError(true)
      return
    }
    updateClaimStatus(dataClaimDetails?.claimNumber, remark)
    handleModalClose()
    setRemark('')
    setShowRemarkError(false)
  }

  const handleSaveClaim = (isSaveClaim: boolean) => {
    setIsSaveClaim(isSaveClaim)
  }

  const handleSubmit = async (e: React.FormEvent, type: 'save' | 'submit') => {
    e.preventDefault()
    if (outpatientPageRef.current) {
      // if (formData.totalBiaya === 0 && type === 'submit') {
      // if (formData.totalBiaya === 0 && type === 'submit') {
      //   toast.error('Total biaya tidak boleh 0, silahkan isi biaya komponen dibawah ini', {
      //     position: 'top-right',
      //     autoClose: 5000,
      //     hideProgressBar: false,
      //   })
      //   return
      // } else if (formData.totalBiaya !== 0 && type === 'submit') {
      //   setShowConfirmation(true)
      // }

      if (type === 'submit') {
        setShowConfirmation(true)
      }
      try {
        console.log('OutpatientPageWrapper - Calling child handleSubmit')

        if (showConfirmation || type === 'save') {
          await outpatientPageRef.current.handleSubmit(e, type)
          console.log('OutpatientPageWrapper - Child handleSubmit completed')
        }

      } catch (error: any) {
        console.error('Error in OutpatientPageWrapper handleSubmit:', error)
        setShowConfirmation(false)
        toast.error(error.message || 'Terjadi kesalahan saat menyimpan data', {
          position: 'top-right',
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: 'light',
        })
      }
    } else {
      console.error('OutpatientPageWrapper - outpatientPageRef.current is null')
    }
  }

  const isEditable = ['Pre-Auth', 'Pre-Registered', 'Registered', 'Pending on FGL'].includes(
    dataClaimDetails?.status || ''
  )

  // Add handlers for Superseding Request modal
  const handleSupersedingClick = (type: string) => {
    setCurrentSupersedingType(type)
    setShowSupersedingModal(true)
  }

  const handleSupersedingModalClose = () => {
    setShowSupersedingModal(false)
    setSupersedingRemark('')
    setShowSupersedingRemarkError(false)
    setCurrentSupersedingType('')
  }

  const handleConfirmSuperseding = async () => {
    if (!supersedingRemark.trim()) {
      setShowSupersedingRemarkError(true)
      return
    }

    try {
      await updateClaimStatusSupersedingRequest(currentSupersedingType, supersedingRemark)
      handleSupersedingModalClose()
      navigate('/builder')
    } catch (error) {
      console.error('Error submitting superseding request:', error)
      toast.error('Failed to submit superseding request', {
        position: 'bottom-right',
        autoClose: 3000,
      })
    }
  }

  return (
    <>
      {/* <ToastContainer
        position='top-right'
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme='light'
      /> */}

      <div style={{ padding: '8px 16px', marginTop: 8 }}>
        <div className="sticky-header">
          <div className='frame-header' style={{ width: '100%' }}>
            <div className='frame-headertop'>
              <div className='frame-menu2'>
                <span className='frame-text36'>{dataClaimDetails?.claimNumber}</span>
                <div className='frame-row25'>
                  <div className='frame-label20'>
                    <span className='frame-text37'>Rawat Jalan</span>
                  </div>
                </div>
              </div>

              <div className='frame-row26'>
                <div className="frame-statuslabel-2">
                  <span className='frame-text45'>
                    {currentStatus}
                  </span>
                </div>
              </div>
              <div className='frame-row26'>
                {/* Add chat icon button here */}
                <button
                  className='btn btn-icon btn-active-light-primary'
                  onClick={() => setIsChatModalOpen(true)}
                  style={{
                    border: 'none',
                    background: 'none',
                    cursor: 'pointer',
                    padding: '5px',
                    marginRight: '-95%',
                  }}
                >
                  <FaComment size={20} color='#059BB6' />

                  {/* Red Dot */}
                  {dataClaimDetails?.chatCounter > 0 && (
                    <span
                      style={{
                        position: 'absolute',
                        top: '4px',
                        right: '2px',
                        minWidth: '12px',
                        height: '14px',
                        backgroundColor: 'red',
                        color: 'white',
                        borderRadius: '50%',
                        fontSize: '10px',
                        fontWeight: 'bold',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        padding: '0 4px',
                        lineHeight: 1,
                      }}
                    >
                      {dataClaimDetails?.chatCounter}
                    </span>
                  )}

                </button>
              </div>
            </div>
            <div className="frame-headerhelper">
              <div className='frame-row29'>
                <span className='frame-text39'>Patient Name</span>
                <span className='frame-text40'>{dataClaimDetails?.memberName}</span>
              </div>
              {activeTab === 'claim' && isEditable && (
                <div style={{ display: 'flex', gap: 12 }}>
                  <button className='btn btn-danger cursor-pointer' onClick={handleCancelClick}>
                    Void
                  </button>
                  <button
                    type='button'
                    className='btn btn-secondary'
                    onClick={(e) => handleSubmit(e, 'save')}
                  >
                    Simpan
                  </button>
                  <button
                    className='frame-button20'
                    style={{
                      backgroundColor: isFormValid ? '#127289' : '#E4E6EF',
                      color: 'white',
                      cursor: isFormValid ? 'pointer' : 'not-allowed',
                      border: 'none',
                      borderRadius: '0.475rem',
                      padding: '0.75rem 1.5rem',
                      transition: 'background-color 0.3s ease',
                    }}
                    onClick={(e) => handleSubmit(e, 'submit')}
                    disabled={!isFormValid}
                  >
                    <span className='frame-text42 Body500Md'>Request FGL</span>
                  </button>
                </div>
              )}
              {currentStatus === 'FGL Released' && (
                <div style={{ display: 'flex', gap: 12 }}>
                  <button
                    type='button'
                    className='frame-button20'
                    style={{
                      backgroundColor: '#2A9D8F',
                      color: 'white',
                      cursor: 'pointer',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '5px',
                      border: 'none',
                      borderRadius: '0.475rem',
                      padding: '0.75rem 1.5rem',
                    }}
                    onClick={() => handleSupersedingClick('FGL')}
                  >
                    FGL Superseding Request
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>

        <div className='frame-tabs' style={tabsContainerStyle}>
          <div
            className={`frame-tab1 ${activeTab === 'claim' ? 'active' : ''}`}
            onClick={() => setActiveTab('claim')}
            style={getTabStyle(activeTab === 'claim')}
          >
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <FaBriefcaseMedical style={{
                ...tabIconStyle,
                ...(activeTab === 'claim' ? activeIconStyle : {})
              }}
              />
              <span style={{
                ...tabTextStyle,
                color: activeTab === 'claim' ? '#059BB6' : '#6D7194'
              }}>
                Claims
              </span>
            </div>
          </div>
          <div
            className={`frame-tab2 ${activeTab === 'dataPasien' ? 'active' : ''}`}
            onClick={() => setActiveTab('dataPasien')}
            style={getTabStyle(activeTab === 'dataPasien')}
          >
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <FaUserCircle
                style={{
                  ...tabIconStyle,
                  ...(activeTab === 'dataPasien' ? activeIconStyle : {}),
                }}
              />
              <span
                style={{
                  ...tabTextStyle,
                  color: activeTab === 'dataPasien' ? '#059BB6' : '#64748B',
                }}
              >
                Data Pasien
              </span>
            </div>
          </div>

          {dataClaimDetails?.status === 'FGL Released' && (
            <div
              className={`frame-tab3 ${activeTab === 'documents' ? 'active' : ''}`}
              onClick={() => setActiveTab('documents')}
              style={getTabStyle(activeTab === 'documents')}
            >
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <FaFile
                  style={{
                    ...tabIconStyle,
                    ...(activeTab === 'documents' ? activeIconStyle : {}),
                  }}
                />
                <span
                  style={{
                    ...tabTextStyle,
                    color: activeTab === 'documents' ? '#059BB6' : '#64748B',
                  }}
                >
                  Documents FGL
                </span>
              </div>
            </div>
          )}
        </div>

        <div className='tab-content'>
          {activeTab === 'claim' && (
            <OutpatientPage
              ref={outpatientPageRef}
              onDefaultDocumentsReady={handleDefaultDocumentsReady}
              onSubmit={handleSubmit}
              claimDetails={claimDetails.claimDetails}
              formData={formData}
              onFormDataChange={handleFormDataChange}
              setShowConfirmation={setShowConfirmation}
              setIsSaveClaim={handleSaveClaim}
            />
          )}
          {activeTab === 'dataPasien' && (
            <PatientPage
              claimDetails={claimDetails.claimDetails}
              formData={formData}
              onFormDataChange={handleFormDataChange}
            />
          )}
          {activeTab === 'documents' &&
            dataClaimDetails?.status === 'FGL Released' && (
              <DocumentView claimDetails={claimDetails} />
            )}
        </div>

        {/* Confirmation Modal */}
        {showConfirmation && (
          <div className='confirmation-modal'>
            <div className='modal-content-confirmation'>
              <h3>Konfirmasi Pengiriman</h3>
              <p>Apakah Anda yakin ingin mengirim data ini?</p>
              <div className='modal-buttons-confirmation'>
                <button className='btn btn-secondary' onClick={() => setShowConfirmation(false)}>
                  Batal
                </button>
                <button
                  className='btn btn-primary'
                  onClick={(e) => {
                    setShowConfirmation(false)
                    handleSubmit(e, 'submit')
                  }}
                  disabled={isLoading}
                >
                  {isLoading ? 'Loading...' : 'Konfirmasi'}
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Metronic Cancel Confirmation Modal */}
        <Modal
          id='kt_modal_cancel_claim'
          show={showCancelModal}
          onHide={handleModalClose}
          aria-hidden='true'
          dialogClassName='modal-dialog modal-dialog-centered'
          contentClassName='modal-content rounded'
        >
          <div className='modal-header pb-0 border-0 justify-content-end'>
            <div
              className='btn btn-sm btn-icon btn-active-color-primary'
              onClick={handleModalClose}
            >
              <IoIosClose size={24} />
            </div>
          </div>

          <div className='modal-body scroll-y px-10 px-lg-15 pt-0 pb-15'>
            <div className='mb-13 text-center'>
              <h1 className='mb-3'>Confirmation of Claim Void</h1>
            </div>

            <div className='d-flex flex-column mb-8'>
              <div className='text-center mb-5'>
                <p className='text-gray-800 fs-6 fw-semibold'>
                  Are you sure you want to void claim {claimDetails?.claimDetails?.claimNumber} on
                  behalf of {claimDetails?.claimDetails?.memberName}?
                  {/* {intl.formatMessage(
                  {id: 'DASHBOARD.MODAL_DESCRIPTION'},
                  {
                    claimNumber: data?.claimNumber,
                    memberName: data?.memberName,
                  }
                )} */}
                </p>
              </div>

              {isConfirmCancel && (
                <div className='form-group'>
                  <label className='required fw-semibold fs-6 mb-2'>Remark</label>
                  <textarea
                    className={`form-control ${showRemarkError ? 'is-invalid' : ''}`}
                    rows={3}
                    value={remark}
                    onChange={(e) => {
                      setRemark(e.target.value)
                      setShowRemarkError(false)
                    }}
                  />
                  {showRemarkError && <div className='invalid-feedback'>Remark is required</div>}
                </div>
              )}
            </div>

            <div className='d-flex flex-center flex-row-fluid pt-12'>
              <button type='reset' className='btn btn-light me-3' onClick={handleModalClose}>
                Cancel
              </button>

              {!isConfirmCancel && (
                <button
                  type='button'
                  className='btn btn-primary'
                  onClick={() => setIsConfirmCancel(true)}
                >
                  Confirm
                </button>
              )}

              {isConfirmCancel && (
                <button
                  type='button'
                  className='btn btn-primary'
                  onClick={handleConfirmCancel}
                  disabled={!remark.trim()}
                >
                  Submit
                </button>
              )}
            </div>
          </div>
        </Modal>

        {/* IGL/FGL Superseding Request Modal */}
        <Modal
          id='kt_modal_superseding_request'
          show={showSupersedingModal}
          onHide={handleSupersedingModalClose}
          aria-hidden='true'
          dialogClassName='modal-dialog modal-dialog-centered'
          contentClassName='modal-content rounded'
        >
          <div className='modal-header pb-0 border-0 justify-content-end'>
            <div
              className='btn btn-sm btn-icon btn-active-color-primary'
              onClick={handleSupersedingModalClose}
            >
              <IoIosClose size={24} />
            </div>
          </div>

          <div className='modal-body scroll-y px-10 px-lg-15 pt-0 pb-15'>
            <div className='mb-13 text-center'>
              <h1 className='mb-3'>{currentSupersedingType} Superseding Request</h1>
            </div>

            <div className='d-flex flex-column mb-8'>
              <div className='text-center mb-5'>
                <p className='text-gray-800 fs-6 fw-semibold'>
                  Please provide a reason for the {currentSupersedingType} superseding request for
                  claim {claimDetails?.claimDetails?.claimNumber} on behalf of{' '}
                  {claimDetails?.claimDetails?.memberName}:
                </p>
              </div>

              <div className='form-group'>
                <label className='required fw-semibold fs-6 mb-2'>
                  Reason for Superseding Request
                </label>
                <textarea
                  className={`form-control ${showSupersedingRemarkError ? 'is-invalid' : ''}`}
                  rows={4}
                  value={supersedingRemark}
                  onChange={(e) => {
                    setSupersedingRemark(e.target.value)
                    setShowSupersedingRemarkError(false)
                  }}
                  placeholder='Enter the reason for the superseding request...'
                  style={{ resize: 'vertical', minHeight: '100px' }}
                />
                {showSupersedingRemarkError && (
                  <div className='invalid-feedback'>Reason is required</div>
                )}
              </div>
            </div>

            <div className='d-flex flex-center flex-row-fluid pt-12'>
              <button
                type='reset'
                className='btn btn-light me-3'
                onClick={handleSupersedingModalClose}
              >
                Cancel
              </button>
              <button
                type='button'
                className='btn btn-primary'
                onClick={handleConfirmSuperseding}
                disabled={!supersedingRemark.trim()}
              >
                Confirm
              </button>
            </div>
          </div>
        </Modal>

        {/* Document modal */}
        {/* <DocumentModal
          isOpen={isChatOpen}
          onClose={() => setIsChatOpen(false)}
          claimNumber={claimDetails?.claimDetails?.claimNumber}
          token={user.currentUser?.token}
        /> */}

        {/* Chat modal */}
        {isChatModalOpen && claimDetails && (
          <ChatModal
            isOpen={isChatModalOpen}
            onClose={() => setIsChatModalOpen(false)}
            message={''}
            claimDetails={claimDetails.claimDetails}
            onRefetchDetailsClaim={refetchDetailsClaim}
          />
        )}

        <style>{`
          .sticky-header {
            margin-top: -70px;
            position: sticky;
            top: 0;
            z-index: 3;
          }
          .tabs {
            display: flex;
            border-bottom: 1px solid #e1e1e1;
            margin-bottom: 16px;
          }
          .tab {
            padding: 12px 16px;
            cursor: pointer;
            background: transparent;
            border: none;
            font-size: 16px;
            color: #6d7194;
          }
          .tab.active {
            border-bottom: 2px solid #0094a2;
            color: #0094a2;
            font-weight: bold;
          }
          .frame-tab.active {
            backgroundColor: '#EBF7F9',
            color: '#059BB6',
            border: '1px solid #E2EDF3',
            boxShadow: '0 2px 4px rgba(0,0,0,0.04)',
          }
          .frame-tabs:hover {
            backgroundColor: '#EBF7F9',
            transform: 'translateY(-1px)',
            boxShadow: '0 4px 6px rgba(0,0,0,0.05)',
          }
          .tab-content {
            padding: 16px;
            background: #f9f9f9;
            border-radius: 8px;
            box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
          }
          .btn-simpan, .btn-kirim {
            padding: 8px 12px;
            border: none;
            border-radius: 4px;
            cursor: pointer;
            color: white;
            background-color: #0094a2; /* Change this color as needed */
            font-size: 14px;
          }
          .btn-kirim {
            background-color: #007bff; /* Different color for Kirim button */
          }
          .btn-simpan:hover, .btn-kirim:hover {
            opacity: 0.8; /* Slightly change opacity on hover */
          }

          /* Modal styles */
          .confirmation-modal {
            position: fixed;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            background-color: rgba(0, 0, 0, 0.5);
            z-index: 1000;
          }
          
          .modal-content-confirmation {
            background-color: white;
            padding: 24px;
            border-radius: 8px;
            width: 400px;
            box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
          }
          
          .modal-content-confirmation h3 {
            margin-top: 0;
            color: #0094a2;
          }
          
          .modal-buttons-confirmation {
            display: flex;
            justify-content: flex-end;
            gap: 12px;
            margin-top: 24px;
          }
        `}</style>
      </div>
    </>
  )
}

export default OutpatientPageWrapper
